export const SET_WEB3_PROVIDER = 'SET_WEB3_PROVIDER';

export const setweb3Provider = (payload) => {
  return {
    type: SET_WEB3_PROVIDER,
    payload: payload,
  };
};
